import { MonthMapping, DaysMapping, WordsMapping } from './types';

export const numberMapping: string[] = ['à¥¦', 'à¥§', 'à¥¨', 'à¥©', 'à¥ª', 'à¥«', 'à¥¬', 'à¥­', 'à¥®', 'à¥¯'];

export const wordsMapping: WordsMapping = {
  year: 'à¤¸à¤¾à¤²',
  month: 'à¤®à¤¹à¤¿à¤¨à¤¾'
};

export const daysMapping: DaysMapping = {
  en: {
    default: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  },
  ne: {
    default: ['à¤à¤à¤¤', 'à¤¸à¥à¤®', 'à¤®à¤à¤à¤²à¥', 'à¤¬à¥à¤§', 'à¤¬à¤¿à¤¹à¥', 'à¤¶à¥à¤à¥à¤°', 'à¤¶à¤¨à¤¿'],
    short: ['à¤', 'à¤¸à¥', 'à¤®à¤', 'à¤¬à¥', 'à¤¬à¤¿', 'à¤¶à¥', 'à¤¶']
  }
};

export const monthsMapping: MonthMapping = {
  en: {
    default: [
      'Baisakh', 'Jestha', 'Asadh', 'Shrawan', 'Bhadra', 'Ashwin', 'Kartik', 'Mangsir', 'Poush', 'Marga', 'Falgun', 'Chaitra'
    ],
    modern: [
      'Baisakh', 'Jeth', 'Asaar', 'Saawn', 'Bhadau', 'Aashoj', 'Kartik', 'Mangsir', 'Push', 'Magh', 'Fagun', 'Chait'
    ],
    short: [
      'Bai', 'Jes', 'Asa', 'Shr', 'Bha', 'Ash', 'Kar', 'Man', 'Pou', 'Mar', 'Fal', 'Cha'
    ]
  },
  ne: {
    default: [
      'à¤¬à¥à¤¶à¤¾à¤', 'à¤à¥à¤·à¥à¤ ', 'à¤à¤·à¤¾à¤¢', 'à¤¶à¥à¤°à¤µà¤£', 'à¤­à¤¾à¤¦à¥à¤°', 'à¤à¤¶à¥à¤µà¤¿à¤¨', 'à¤à¤¾à¤°à¥à¤¤à¤¿à¤', 'à¤®à¤à¤¸à¤¿à¤°', 'à¤ªà¥à¤·', 'à¤®à¤¾à¤°à¥à¤', 'à¤«à¤¾à¤²à¥à¤à¥à¤¨', 'à¤à¥à¤¤à¥à¤°'
    ],
    modern: [
      'à¤¬à¥à¤¶à¤¾à¤', 'à¤à¥à¤ ', 'à¤à¤¸à¤¾à¤°', 'à¤¸à¤¾à¤à¤¨', 'à¤­à¤¦à¥', 'à¤à¤¶à¥à¤', 'à¤à¤¾à¤°à¥à¤¤à¤¿à¤', 'à¤®à¤à¤¸à¤¿à¤°', 'à¤ªà¥à¤·', 'à¤®à¤¾à¤', 'à¤«à¤¾à¤à¥à¤¨', 'à¤à¥à¤¤'
    ],
    short: [
      'à¤¬à¥', 'à¤à¥', 'à¤', 'à¤¶à¥à¤°à¤¾', 'à¤­à¤¾', 'à¤', 'à¤à¤¾', 'à¤®à¤', 'à¤ªà¥', 'à¤®à¤¾', 'à¤«à¤¾', 'à¤à¥'
    ]
  }
};
